import React from 'react';

interface BfiNumberCellParameters {
    bfiNumber: string;
    bfiNumberSuffix: string;
    isPortfolio: boolean;
}

export const BfiNumberCell: React.FC<BfiNumberCellParameters> = ({ bfiNumber, bfiNumberSuffix, isPortfolio }) => {
    if (isPortfolio) {
        if (bfiNumber.length > 1) {
            return `${bfiNumber}.${bfiNumberSuffix}`;
        } else {
            return `${bfiNumber}.0${bfiNumberSuffix}`;
        }
    }

    return bfiNumber;
};
